import React from 'react'
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  useTheme,
  useMediaQuery
} from '@mui/material'

import { Plus } from 'src/assets/general/Plus'
import { Search } from '@mui/icons-material'
import { TNNotification } from 'src/assets/topnav/TNNotification'

const NewNotificationSearchAdd = ({ handleNotificationClick, handleSearch, handleAdd, canEdit }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        gap: 2,
        mb: 1
      }}
    >
      <IconButton
        onClick={handleNotificationClick}
        sx={{
          border: `1px solid ${theme.palette.grey[300]}`,
          p: 1,
          borderRadius: '8px',
          height: 50,
          width: 50,
          display: 'none'
        }}
      >
        <TNNotification />
      </IconButton>

      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Search />
            </InputAdornment>
          )
        }}
        variant='outlined'
        size='small'
        sx={{
          backgroundColor: 'white',
          width: { xs: '100%', sm: '100%', md: '30%', lg: '30%' },
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderRadius: '6px', borderColor: theme.palette.grey[400] }
          },
          '& div input': {
            py: 1.3,
            fontSize: '13px',
            fontWeight: 400,
            lineHeight: '16px',
            letterSpacing: '0em',
            '&::placeholder': {
              color: 'rgba(40, 40, 123, 0.5)'
            }
          }
        }}
        placeholder='Search campaigns...'
        onChange={handleSearch}
      />
      {canEdit && (
        <Button
          sx={{
            textTransform: 'none',
            '&:hover': { backgroundColor: '#4338ca' },
            width: { xs: '100%', sm: 'auto' },
            backgroundColor: `${theme.palette.primary.main}`,
            color: 'white'
          }}
          variant='contained'
          onClick={handleAdd}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Plus />
          </Box>
          {isMobile ? 'Create' : ' Create new campaign'}
        </Button>
      )}
    </Box>
  )
}

export default NewNotificationSearchAdd
